module.exports = {
    apiUri: 'https://bakery-backend-api.onrender.com'
}